
import { useNavigate, useParams } from 'react-router-dom';
import '../App.css';
import { BackgroundStyle, BigHeading, FlexContainer, ListContainer, LongBlueButton, SearchingBoxContainer } from '../assets/style';
import MainContent from '../components/MainContent';
import { contractPageName } from '../components/PageName';
import SearchBox from '../components/SearchBox';
import SearchDatePicker from '../components/SearchDatePicker';
import RecordTable, { TableHeader } from '../components/RecordTable';
import { useEffect, useState, useRef } from 'react';
import dayjs from 'dayjs';
import SearchDropDownList from '../components/SearchDropDownList';
import { useLazyGetAlertDetailQuery, useLazyGetAlertListingQuery } from '../features/alert/alertSlice';
import { Box, CircularProgress, Modal, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";


const AlertListingPage = () => {
    const {t, i18n} = useTranslation();
    const [type, setType] = useState<string | undefined>()
    const [startDate, setStartDate] = useState(dayjs(null))
    const [endDate, setEndDate] = useState(dayjs(null))

    const [getAlertList] = useLazyGetAlertListingQuery()

    const [rows, setRows] = useState([])
    const navigate = useNavigate()
    const [open, setOpen] = useState<boolean>(false)
    const alertDetailIdRef = useRef<number | undefined>(undefined)

    const columns: TableHeader[] = [
        { field: 'title', headerName: t('Title'), width: 200, isSortable: true },
        { field: 'type', headerName: t('Type'), width: 200, isSortable: false },
        { field: 'createDate', headerName: t('Create Date'), width: 200, isSortable: false },
    ];

    const handleRowClick = function (row: any) {
        alertDetailIdRef.current = row.alertId
        setOpen(true)
    }

    const handleSearchClick = () => {
        try {
            getAlertList({
                type: type,
                createDateFrom: startDate.isValid() ? startDate?.toISOString() : undefined,
                createDateTo: endDate.isValid() ? endDate?.toISOString() : undefined
            }).then((respone) => respone?.data?.records)
                .then((d) => {
                    setRows(d.map((item: { id: any; title: any; type: any; content: any; createDate: any }) => {
                        return {
                            alertId: item.id,
                            title: item.title,
                            type: item.type,
                            content: item.content,
                            createDate: item.createDate,
                        };
                    }))
                })
        } catch (error) {

        }
    }

    useEffect(() => {
        handleSearchClick();
    }, [])


    return (
        <MainContent type={contractPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer>
                    <BigHeading>{t("Alert List")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <SearchDropDownList title={t("Type")} value={type} handleValueChange={(e: any) => { }} items={["", "", ""]} />
                                <SearchDatePicker title={t("Start Date")} value={startDate} setMethod={setStartDate} />
                                <SearchDatePicker title={t("End Date")} value={endDate} setMethod={setEndDate} />
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={handleSearchClick}>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                        </SearchBox>
                    </SearchingBoxContainer>
                    <RecordTable checkbox={false} getRowId={e => e.alertId} columns={columns} rows={rows} onClick={handleRowClick}></RecordTable>
                </ListContainer>
            </BackgroundStyle>
            <AlertDetailModal open={open} setOpen={setOpen} alertDetailId={alertDetailIdRef.current} />
        </MainContent>
    );
};

const AlertDetailModal = ({ open, setOpen, alertDetailId }: { open: boolean, setOpen: (x: boolean) => void, alertDetailId: number | undefined }) => {
    const [getAlertDetail, result] = useLazyGetAlertDetailQuery()
    const {t, i18n} = useTranslation();

    useEffect(() => {
        if (alertDetailId != undefined)
            getAlertDetail(alertDetailId)
    }, [alertDetailId])

    return (
        <Modal
            sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            open={open}
            onClose={() => { setOpen(false) }}
        >
            <Box sx={{ backgroundColor: "white", width: "50%", maxHeight: "70vh", borderRadius: "10px", paddingLeft: "20px", paddingRight: "20px", }}>
                {
                    result.isLoading &&
                    <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                        <CircularProgress />
                    </div>
                }
                {
                    result.isSuccess &&
                    <Box sx={{ overflow: "auto", maxHeight: "calc(70vh - 40px)" }}>
                        <h3>{t("Alert Detail")}</h3>
                        <hr></hr>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 7fr", rowGap: '10px' }}>
                            <div style={{ fontWeight: "bold" }}>{t("Title")}:</div>
                            <div>{result.data.title}</div>
                            <div style={{ fontWeight: "bold" }}>{t("Type")}:</div>
                            <div>{result.data.type}</div>
                            <div style={{ fontWeight: "bold" }}>{t("Create Date")}:</div>
                            <div>{result.data.createDate}</div>
                            <div style={{ fontWeight: "bold" }}>{t("Content")}:</div>
                            <div>{result.data.content}</div>
                            <div style={{ fontWeight: "bold" }}>{t("Occurred Location")}:</div>
                            <div>{result.data.locationName}</div>
                            <div style={{ fontWeight: "bold" }}>{t("Involved Worker")}:</div>
                            <div>{result.data.workerName}</div>
                        </div>
                    </Box>
                }
            </Box>
        </Modal >
    )
}

export default AlertListingPage